import React, { HTMLAttributes } from 'react';
import { PageIndicatorItem } from './PageIndicatorItem';
import { Stack } from '../stack';
import { useRover } from '../../hooks/useRover';
import { size_styles } from './styles';
import { PageIndicatorItemSize } from './types';

export interface PageIndicatorProps extends HTMLAttributes<HTMLDivElement> {
  disabled?: boolean;
  totalPages: number;
  currentPage: number;
  onChangePage?: (page: number) => void;
  /** @default 'medium' */
  size?: PageIndicatorItemSize;
}

export const PageIndicator: React.FC<PageIndicatorProps> = ({
  disabled,
  totalPages,
  currentPage,
  onChangePage,
  size = 'medium',
  ...props
}) => {
  const { gap } = size_styles[size];

  const { getRoverItemProps } = useRover({
    index: currentPage - 1,
    onIndexChange: (index, is_selecting) => {
      if (is_selecting) {
        onChangePage?.(index + 1);
      }
    },
    length: totalPages,
  });

  return (
    <Stack gap={gap} role='tablist' justify='center' {...props}>
      {Array.from({ length: totalPages }).map((_, page) => (
        <PageIndicatorItem
          key={page}
          page={page + 1}
          isSelected={page + 1 === currentPage}
          onClick={onChangePage}
          disabled={disabled}
          size={size}
          {...getRoverItemProps(page, {})}
        />
      ))}
    </Stack>
  );
};
